const currency = 
[
  {
    "symbol": "$",
    "symbol_native": "$",
    "name": "US Dollar",
    "code": "USD",
    "digit": 2,
    "rounding": 0
  },
  {
    "symbol": "€",
    "symbol_native": "€",
    "name": "Euro",
    "code": "EUR",
    "digit": 2,
    "rounding": 0
  },
  {
    "symbol": "£",
    "symbol_native": "£",
    "name": "British Pound",
    "code": "GBP",
    "digit": 2,
    "rounding": 0
  },
  {
    "symbol": "IDR",
    "symbol_native": "Rp",
    "name": "Indonesian Rupiah",
    "code": "IDR",
    "digit": 0,
    "rounding": 0
  },
  {
    "symbol": "A$",
    "symbol_native": "$",
    "name": "Australian Dollar",
    "code": "AUD",
    "digit": 2,
    "rounding": 0
  },
  {
    "symbol": "MYR",
    "symbol_native": "RM",
    "name": "Malaysian Ringgit",
    "code": "MYR",
    "digit": 2,
    "rounding": 0
  },
  {
    "symbol": "CA$",
    "symbol_native": "$",
    "name": "Canadian Dollar",
    "code": "CAD",
    "digit": 2,
    "rounding": 0
  },
  {
    "symbol": "ARS",
    "symbol_native": "$",
    "name": "Argentine Peso",
    "code": "ARS",
    "digit": 2,
    "rounding": 0
  },
  {
    "symbol": "AZN",
    "symbol_native": "₼",
    "name": "Azerbaijani Manat",
    "code": "AZN",
    "digit": 2,
    "rounding": 0
  },
  {
    "symbol": "BHD",
    "symbol_native": "د.ب.‏",
    "name": "Bahraini Dinar",
    "code": "BHD",
    "digit": 3,
    "rounding": 0
  },
  {
    "symbol": "R$",
    "symbol_native": "R$",
    "name": "Brazilian Real",
    "code": "BRL",
    "digit": 2,
    "rounding": 0
  },
  {
    "symbol": "BGN",
    "symbol_native": "лв.",
    "name": "Bulgarian Lev",
    "code": "BGN",
    "digit": 2,
    "rounding": 0
  },
  {
    "symbol": "CFA",
    "symbol_native": "CFA",
    "name": "West African CFA Franc",
    "code": "XOF",
    "digit": 0,
    "rounding": 0
  },
  {
    "symbol": "CLP",
    "symbol_native": "$",
    "name": "Chilean Peso",
    "code": "CLP",
    "digit": 0,
    "rounding": 0
  },
  {
    "symbol": "CN¥",
    "symbol_native": "¥",
    "name": "Chinese Yuan",
    "code": "CNY",
    "digit": 2,
    "rounding": 0
  },
  {
    "symbol": "COP",
    "symbol_native": "$",
    "name": "Colombian Peso",
    "code": "COP",
    "digit": 0,
    "rounding": 0
  },
  {
    "symbol": "CZK",
    "symbol_native": "Kč",
    "name": "Czech Koruna",
    "code": "CZK",
    "digit": 2,
    "rounding": 0
  },
  {
    "symbol": "DKK",
    "symbol_native": "kr.",
    "name": "Danish Krone",
    "code": "DKK",
    "digit": 2,
    "rounding": 0
  },
  {
    "symbol": "EGP",
    "symbol_native": "ج.م.‏",
    "name": "Egyptian Pound",
    "code": "EGP",
    "digit": 2,
    "rounding": 0
  },
  {
    "symbol": "FJD",
    "symbol_native": "$",
    "name": "Fijian Dollar",
    "code": "FJD",
    "digit": 2,
    "rounding": 0
  },
  {
    "symbol": "GEL",
    "symbol_native": "₾",
    "name": "Georgian Lari",
    "code": "GEL",
    "digit": 2,
    "rounding": 0
  },
  {
    "symbol": "HK$",
    "symbol_native": "HK$",
    "name": "Hong Kong Dollar",
    "code": "HKD",
    "digit": 2,
    "rounding": 0
  },
  {
    "symbol": "HUF",
    "symbol_native": "Ft",
    "name": "Hungarian Forint",
    "code": "HUF",
    "digit": 2,
    "rounding": 0
  },
  {
    "symbol": "₹",
    "symbol_native": "₹",
    "name": "Indian Rupee",
    "code": "INR",
    "digit": 2,
    "rounding": 0
  },
  {
    "symbol": "¥",
    "symbol_native": "￥",
    "name": "Japanese Yen",
    "code": "JPY",
    "digit": 0,
    "rounding": 0
  },
  {
    "symbol": "JOD",
    "symbol_native": "د.أ.‏",
    "name": "Jordanian Dinar",
    "code": "JOD",
    "digit": 3,
    "rounding": 0
  },
  {
    "symbol": "KZT",
    "symbol_native": "₸",
    "name": "Kazakhstani Tenge",
    "code": "KZT",
    "digit": 2,
    "rounding": 0
  },
  {
    "symbol": "₩",
    "symbol_native": "₩",
    "name": "South Korean Won",
    "code": "KRW",
    "digit": 0,
    "rounding": 0
  },
  {
    "symbol": "KWD",
    "symbol_native": "د.ك.‏",
    "name": "Kuwaiti Dinar",
    "code": "KWD",
    "digit": 3,
    "rounding": 0
  },
  {
    "symbol": "MX$",
    "symbol_native": "$",
    "name": "Mexican Peso",
    "code": "MXN",
    "digit": 2,
    "rounding": 0
  },
  {
    "symbol": "MDL",
    "symbol_native": "L",
    "name": "Moldovan Leu",
    "code": "MDL",
    "digit": 2,
    "rounding": 0
  },
  {
    "symbol": "NAD",
    "symbol_native": "$",
    "name": "Namibian Dollar",
    "code": "NAD",
    "digit": 2,
    "rounding": 0
  },
  {
    "symbol": "₪",
    "symbol_native": "₪",
    "name": "Israeli New Shekel",
    "code": "ILS",
    "digit": 2,
    "rounding": 0
  },
  {
    "symbol": "NT$",
    "symbol_native": "$",
    "name": "New Taiwan Dollar",
    "code": "TWD",
    "digit": 2,
    "rounding": 0
  },
  {
    "symbol": "NZ$",
    "symbol_native": "$",
    "name": "New Zealand Dollar",
    "code": "NZD",
    "digit": 2,
    "rounding": 0
  },
  {
    "symbol": "NOK",
    "symbol_native": "kr",
    "name": "Norwegian Krone",
    "code": "NOK",
    "digit": 2,
    "rounding": 0
  },
  {
    "symbol": "OMR",
    "symbol_native": "ر.ع.‏",
    "name": "Omani Rial",
    "code": "OMR",
    "digit": 3,
    "rounding": 0
  },
  {
    "symbol": "PLN",
    "symbol_native": "zł",
    "name": "Polish Zloty",
    "code": "PLN",
    "digit": 2,
    "rounding": 0
  },
  {
    "symbol": "QAR",
    "symbol_native": "ر.ق.‏",
    "name": "Qatari Rial",
    "code": "QAR",
    "digit": 2,
    "rounding": 0
  },
  {
    "symbol": "RON",
    "symbol_native": "RON",
    "name": "Romanian Leu",
    "code": "RON",
    "digit": 2,
    "rounding": 0
  },
  {
    "symbol": "RUB",
    "symbol_native": "₽",
    "name": "Russian Ruble",
    "code": "RUB",
    "digit": 2,
    "rounding": 0
  },
  {
    "symbol": "SAR",
    "symbol_native": "ر.س.‏",
    "name": "Saudi Riyal",
    "code": "SAR",
    "digit": 2,
    "rounding": 0
  },
  {
    "symbol": "SGD",
    "symbol_native": "$",
    "name": "Singapore Dollar",
    "code": "SGD",
    "digit": 2,
    "rounding": 0
  },
  {
    "symbol": "ZAR",
    "symbol_native": "R",
    "name": "South African Rand",
    "code": "ZAR",
    "digit": 2,
    "rounding": 0
  },
  {
    "symbol": "SEK",
    "symbol_native": "kr",
    "name": "Swedish Krona",
    "code": "SEK",
    "digit": 2,
    "rounding": 0
  },
  {
    "symbol": "CHF",
    "symbol_native": "CHF",
    "name": "Swiss Franc",
    "code": "CHF",
    "digit": 2,
    "rounding": 0
  },
  {
    "symbol": "THB",
    "symbol_native": "THB",
    "name": "Thai Baht",
    "code": "THB",
    "digit": 2,
    "rounding": 0
  },
  {
    "symbol": "TRY",
    "symbol_native": "₺",
    "name": "Turkish Lira",
    "code": "TRY",
    "digit": 2,
    "rounding": 0
  },
  {
    "symbol": "AED",
    "symbol_native": "د.إ.‏",
    "name": "United Arab Emirates Dirham",
    "code": "AED",
    "digit": 2,
    "rounding": 0
  },
  {
    "symbol": "UAH",
    "symbol_native": "₴",
    "name": "Ukrainian Hryvnia",
    "code": "UAH",
    "digit": 2,
    "rounding": 0
  },
  {
    "symbol": "₱",
    "symbol_native": "₱",
    "name": "Philippine Peso",
    "code": "PHP",
    "digit": 2,
    "rounding": 0
  }

]
export default currency;


// WEBPACK FOOTER //
// ./src/data/currency.js